export default __webpack_public_path__ + "static/media/client1.4ad86d94.png";